import React from 'react';
import { css } from "styled-components";

import { getCardContents } from './getCardContents';
import BasicCard from '../basic/elements/BasicCard';

import theme from '../../styles/theme';

const { breakPoints: { mobileFirstScreenQuery } } = theme;

const styles = css`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 40px;
    gap: 20px;

    .flex-item {
        flex: 0 0 33.333%;
        display: flex;
        padding: 10px; /* gutter width */
    }
    
    ${mobileFirstScreenQuery.medium} {
        flex-wrap: nowrap;
    }
`

const ThreeCardList = ({ cards }) => {
    return (
        <div css={styles}>
            {cards.map((card, index) => {
                return (
                    <BasicCard {...getCardContents(card)} index={index} />
                )
            })}
        </div>
    )
}
 
export default ThreeCardList;